import batchedUpdates from 'lib/batched-updates'
import { SetStateAction, useEffect, useState } from 'react'

type Subscriber = () => void

function makePubSubHook<S>(
  defaultState: S
): [(setState: SetStateAction<S>) => void, () => S] {
  let curState: S = defaultState

  const subscribers = new Set<Subscriber>()

  function setState(setState: SetStateAction<S>) {
    const newState =
      typeof setState === 'function'
        ? (setState as Function)(curState)
        : setState
    if (curState === newState) {
      return
    }
    curState = newState
    subscribers.forEach((subscriber) => {
      batchedUpdates(() => {
        subscriber()
      })
    })
  }

  function hook() {
    const [state, setState] = useState(curState)

    useEffect(() => {
      batchedUpdates(() => {
        setState(curState)
      })
      const subscriber = () => {
        setState(curState)
      }
      subscribers.add(subscriber)
      return () => {
        subscribers.delete(subscriber)
      }
    }, [])

    return state
  }

  return [setState, hook]
}

export default makePubSubHook
